module.exports = __webpack_public_path__ + "static/media/join_banner.e408f012.png";